import { Helmet } from "react-helmet-async";

const BASE_URL = "https://www.indusport.com.br";
const DEFAULT_IMAGE = `${BASE_URL}/favicon.png`;

interface SEOMetaProps {
  title: string;
  description: string;
  canonical: string;
  ogImage?: string;
}

const SEOMeta = ({ title, description, canonical, ogImage = DEFAULT_IMAGE }: SEOMetaProps) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    {/* A canônica é injetada estaticamente por rota no build (scripts/prerender.mjs),
        para ser única e visível aos crawlers sem depender da execução do JS. */}
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={`${BASE_URL}${canonical}`} />
    <meta property="og:image" content={ogImage} />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={ogImage} />
  </Helmet>
);

export default SEOMeta;
